export interface Work {
  id: string;
  title: string;
  type: 'movie' | 'tv';
  year: number;
  region: string;
  genres: string[];
  rating: number;
  duration?: string;
  episodes?: number;
  director: string;
  cast: string[];
  poster: string;
  backdrop: string;
  heat: number;
  updatedAt: string;
  synopsis: string;
  featured: boolean;
}

export const works: Work[] = [
  {
    id: 'chang-an-ye-xing',
    title: '长安夜行',
    type: 'movie',
    year: 2025,
    region: '中国大陆',
    genres: ['古装', '悬疑'],
    rating: 8.7,
    duration: '128分钟',
    director: '陈望山',
    cast: ['林知远', '苏晚晴', '周牧云'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20capital%20city%20at%20night%20with%20red%20lanterns%20and%20misty%20streets%2C%20lone%20figure%20in%20dark%20robe%2C%20dramatic%20moonlight%2C%20mysterious%20atmosphere%2C%20deep%20blue%20and%20amber%20tones%2C%20movie%20poster%20style%20without%20text&width=600&height=900&seq=film-ca-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=panoramic%20ancient%20chinese%20city%20skyline%20at%20midnight%20with%20glowing%20lanterns%2C%20misty%20mountain%20silhouettes%2C%20moody%20cinematic%20lighting%2C%20deep%20indigo%20sky%20and%20warm%20amber%20glow%2C%20epic%20film%20still%20without%20text&width=1600&height=900&seq=film-ca-backdrop&orientation=landscape',
    heat: 9820,
    updatedAt: '2025-09-28',
    synopsis: '盛唐长安，一连串离奇命案打破了繁华表象。大理寺少卿与街头说书人被迫联手，在宵禁的夜色中追查一枚失落的铜牌，却发现真相直指二十年前的一桩旧案。',
    featured: true,
  },
  {
    id: 'xing-hai-gui-tu',
    title: '星海归途',
    type: 'movie',
    year: 2025,
    region: '中国大陆',
    genres: ['科幻', '剧情'],
    rating: 8.3,
    duration: '142分钟',
    director: '何岸',
    cast: ['沈青禾', '陆行舟', '方鸣'],
    poster: 'https://readdy.ai/api/search-image?query=sci%20fi%20astronaut%20silhouette%20facing%20a%20vast%20colorful%20nebula%2C%20lone%20spaceship%20in%20deep%20space%2C%20glowing%20orange%20and%20teal%20clouds%2C%20emotional%20cinematic%20lighting%2C%20movie%20poster%20composition%20without%20text&width=600&height=900&seq=film-xh-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=epic%20deep%20space%20scene%20with%20distant%20planet%20and%20warm%20nebula%20clouds%2C%20small%20exploration%20vessel%2C%20cinematic%20sci%20fi%20film%20still%2C%20rich%20orange%20and%20dark%20blue%20palette%20without%20text&width=1600&height=900&seq=film-xh-backdrop&orientation=landscape',
    heat: 8640,
    updatedAt: '2025-09-20',
    synopsis: '一艘执行深空补给任务的飞船在返航途中失联，唯一幸存的导航员必须独自穿越星海，带回足以改变地球命运的样本，也要面对自己被困多年的记忆。',
    featured: true,
  },
  {
    id: 'wu-sheng-zheng-ci',
    title: '无声证词',
    type: 'movie',
    year: 2024,
    region: '中国香港',
    genres: ['犯罪', '悬疑'],
    rating: 8.1,
    duration: '118分钟',
    director: '麦子扬',
    cast: ['郑家豪', '苏若冰', '冯家辉'],
    poster: 'https://readdy.ai/api/search-image?query=noir%20hong%20kong%20rainy%20alley%20at%20night%2C%20determined%20detective%20in%20trench%20coat%2C%20neon%20reflections%20on%20wet%20ground%2C%20tense%20crime%20thriller%20mood%2C%20cool%20blue%20with%20orange%20neon%2C%20poster%20style%20without%20text&width=600&height=900&seq=film-ws-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=hong%20kong%20harbour%20skyline%20at%20night%20in%20heavy%20rain%2C%20neon%20signs%20reflecting%20on%20water%2C%20cinematic%20crime%20thriller%20film%20still%2C%20moody%20blue%20and%20amber%20palette%20without%20text&width=1600&height=900&seq=film-ws-backdrop&orientation=landscape',
    heat: 7210,
    updatedAt: '2025-08-30',
    synopsis: '一名失语的关键证人掌握着连环案件唯一的真相。年轻的检控官在层层压力下坚持追查，用一叠无声的证词撬开了尘封多年的秘密。',
    featured: false,
  },
  {
    id: 'summer-xie-zou-qu',
    title: '夏日协奏曲',
    type: 'movie',
    year: 2024,
    region: '日本',
    genres: ['爱情', '剧情'],
    rating: 8.5,
    duration: '112分钟',
    director: '佐藤健一',
    cast: ['桥本遥', '山田凉', '中村由纪'],
    poster: 'https://readdy.ai/api/search-image?query=romantic%20seaside%20town%20in%20golden%20summer%20sunset%2C%20young%20couple%20on%20a%20wooden%20pier%2C%20warm%20sunlight%20and%20sea%20breeze%2C%20gentle%20nostalgic%20film%20look%2C%20soft%20orange%20and%20cream%20tones%2C%20poster%20without%20text&width=600&height=900&seq=film-xr-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=quiet%20japanese%20seaside%20railway%20by%20the%20sea%20in%20summer%2C%20golden%20hour%20light%2C%20gentle%20waves%20and%20warm%20sky%2C%20nostalgic%20romance%20film%20still%2C%20soft%20peach%20and%20amber%20palette%20without%20text&width=1600&height=900&seq=film-xr-backdrop&orientation=landscape',
    heat: 6980,
    updatedAt: '2025-08-18',
    synopsis: '钢琴专业的女孩在海边小镇度过最后一个夏天，遇见了修船的聋哑青年。两个无法用语言沟通的人，用一段未完成的旋律写下了属于彼此的告别。',
    featured: false,
  },
  {
    id: 'huang-yuan-lie-shou',
    title: '荒原猎手',
    type: 'movie',
    year: 2025,
    region: '美国',
    genres: ['动作', '冒险'],
    rating: 7.8,
    duration: '134分钟',
    director: 'Marcus Reed',
    cast: ['戴恩·卡特', '莉亚·莫里森', '伊桑·布莱克'],
    poster: 'https://readdy.ai/api/search-image?query=rugged%20lone%20hunter%20standing%20in%20vast%20red%20desert%20canyon%2C%20dust%20and%20dramatic%20sunlight%2C%20action%20adventure%20atmosphere%2C%20strong%20orange%20and%20deep%20shadow%20contrast%2C%20movie%20poster%20style%20without%20text&width=600&height=900&seq=film-hy-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=sweeping%20desert%20canyon%20landscape%20at%20sunset%20with%20sandstorm%20in%20the%20distance%2C%20cinematic%20action%20film%20still%2C%20warm%20rust%20orange%20and%20dark%20blue%20sky%20without%20text&width=1600&height=900&seq=film-hy-backdrop&orientation=landscape',
    heat: 8120,
    updatedAt: '2025-09-12',
    synopsis: '荒原上的赏金猎人为追捕一名逃犯深入无人区，却在沙暴中发现了被掩埋的营地与一个更大的阴谋。他必须在天亮之前做出选择：完成交易，还是守住最后的底线。',
    featured: true,
  },
  {
    id: 'lao-zhai-li-de-guang',
    title: '老宅里的光',
    type: 'movie',
    year: 2023,
    region: '中国大陆',
    genres: ['家庭', '剧情'],
    rating: 8.9,
    duration: '106分钟',
    director: '苏婉',
    cast: ['何玉兰', '李承泽', '陈小满'],
    poster: 'https://readdy.ai/api/search-image?query=warm%20nostalgic%20chinese%20old%20courtyard%20house%20at%20dusk%2C%20elderly%20grandmother%20by%20a%20glowing%20window%2C%20soft%20lamp%20light%2C%20tender%20family%20drama%20mood%2C%20amber%20and%20cream%20tones%2C%20poster%20without%20text&width=600&height=900&seq=film-lz-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=traditional%20chinese%20courtyard%20neighborhood%20at%20warm%20evening%2C%20soft%20lantern%20glow%20from%20windows%2C%20peaceful%20family%20drama%20film%20still%2C%20golden%20amber%20and%20cream%20palette%20without%20text&width=1600&height=900&seq=film-lz-backdrop&orientation=landscape',
    heat: 6430,
    updatedAt: '2025-07-22',
    synopsis: '外婆去世后，一家三代人回到即将拆迁的老宅整理遗物。在翻找旧物的过程里，被搁置多年的误会与牵挂慢慢浮出水面，他们终于学会好好告别。',
    featured: false,
  },
  {
    id: 'di-qi-feng-you-jian',
    title: '第七封邮件',
    type: 'movie',
    year: 2024,
    region: '韩国',
    genres: ['悬疑', '惊悚'],
    rating: 8.0,
    duration: '121分钟',
    director: '朴振宇',
    cast: ['金敏俊', '李秀雅', '朴在赫'],
    poster: 'https://readdy.ai/api/search-image?query=dark%20moody%20office%20at%20night%20lit%20only%20by%20a%20laptop%20screen%2C%20tense%20figure%20reading%20a%20message%2C%20psychological%20thriller%20atmosphere%2C%20cold%20blue%20with%20a%20hint%20of%20orange%2C%20poster%20without%20text&width=600&height=900&seq=film-dq-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=rain%20soaked%20seoul%20city%20street%20at%20night%20from%20above%2C%20glowing%20windows%20and%20traffic%20lights%2C%20tense%20thriller%20film%20still%2C%20cool%20blue%20and%20orange%20accent%20palette%20without%20text&width=1600&height=900&seq=film-dq-backdrop&orientation=landscape',
    heat: 7550,
    updatedAt: '2025-08-05',
    synopsis: '一名网络编辑连续收到六封匿名邮件，每一封都预告了一起即将发生的事故。当她收到第七封时，收件人写的是她自己的名字，而发件时间就在明天。',
    featured: false,
  },
  {
    id: 'yun-shang-zhi-cheng',
    title: '云上之城',
    type: 'movie',
    year: 2025,
    region: '中国大陆',
    genres: ['动画', '奇幻'],
    rating: 8.6,
    duration: '98分钟',
    director: '罗一舟',
    cast: ['乔木', '夏晚', '程知白'],
    poster: 'https://readdy.ai/api/search-image?query=whimsical%20floating%20city%20above%20the%20clouds%20with%20colorful%20banners%20and%20airships%2C%20young%20hero%20looking%20upward%2C%20dreamy%20animated%20film%20style%2C%20teal%20and%20warm%20orange%20palette%2C%20poster%20without%20text&width=600&height=900&seq=film-yz-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=fantasy%20city%20floating%20among%20golden%20sunset%20clouds%20with%20soaring%20airships%2C%20magical%20animated%20film%20still%2C%20rich%20orange%20and%20soft%20blue%20palette%20without%20text&width=1600&height=900&seq=film-yz-backdrop&orientation=landscape',
    heat: 9030,
    updatedAt: '2025-10-02',
    synopsis: '在漂浮于云层之上的城市里，只会修风筝的女孩意外唤醒了沉睡的守护巨兽。为了让家园不坠入云海，她和伙伴踏上了一段寻找天空之心的冒险。',
    featured: true,
  },
  {
    id: 'yesterday-zhi-hai',
    title: '昨日之海',
    type: 'movie',
    year: 2023,
    region: '英国',
    genres: ['剧情', '文艺'],
    rating: 8.4,
    duration: '115分钟',
    director: 'Eleanor Hayes',
    cast: ['菲奥娜·格兰特', '詹姆斯·威尔'],
    poster: 'https://readdy.ai/api/search-image?query=melancholic%20british%20coastline%20in%20overcast%20weather%2C%20lone%20woman%20in%20a%20long%20coat%20by%20the%20cliff%2C%20quiet%20literary%20drama%20mood%2C%20muted%20teal%20and%20cream%20tones%2C%20poster%20without%20text&width=600&height=900&seq=film-zr-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=moody%20english%20seaside%20cliffs%20under%20soft%20grey%20sky%2C%20distant%20lighthouse%2C%20calm%20literary%20drama%20film%20still%2C%20muted%20blue%20and%20cream%20palette%20without%20text&width=1600&height=900&seq=film-zr-backdrop&orientation=landscape',
    heat: 5210,
    updatedAt: '2025-06-30',
    synopsis: '一位海洋学家退休后回到童年住过的小镇，试图写完搁置多年的手稿。在海边的旧书店里，她重新遇见了那个改变她一生的夏天。',
    featured: false,
  },
  {
    id: 'lie-yan-zhui-xiong',
    title: '烈焰追凶',
    type: 'movie',
    year: 2025,
    region: '中国香港',
    genres: ['动作', '犯罪'],
    rating: 7.6,
    duration: '126分钟',
    director: '徐景天',
    cast: ['谭俊', '吴美玲', '何国栋'],
    poster: 'https://readdy.ai/api/search-image?query=intense%20action%20scene%20of%20a%20determined%20officer%20amid%20city%20fire%20and%20smoke%2C%20dramatic%20orange%20flames%2C%20high%20stakes%20crime%20thriller%20mood%2C%20deep%20shadow%20with%20warm%20glow%2C%20poster%20without%20text&width=600&height=900&seq=film-ly-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=city%20industrial%20district%20at%20night%20with%20glowing%20fire%20and%20sparks%2C%20dramatic%20cinematic%20action%20film%20still%2C%20orange%20fire%20and%20dark%20blue%20shadow%20without%20text&width=1600&height=900&seq=film-ly-backdrop&orientation=landscape',
    heat: 6870,
    updatedAt: '2025-09-05',
    synopsis: '一场仓库大火牵出跨境走私网络，性格火爆的警队队长被迫与冷静的火灾调查员合作。当线索指向自己的旧日战友，他必须在职责与情义之间做出抉择。',
    featured: false,
  },
  {
    id: 'mi-cheng-dang-an',
    title: '迷城档案',
    type: 'tv',
    year: 2025,
    region: '中国大陆',
    genres: ['悬疑', '剧情'],
    rating: 8.8,
    episodes: 32,
    director: '张启明',
    cast: ['白鹿鸣', '顾清欢', '陆之言'],
    poster: 'https://readdy.ai/api/search-image?query=modern%20chinese%20city%20in%20rain%20at%20night%20seen%20through%20a%20window%2C%20detective%20studying%20a%20wall%20of%20clues%2C%20tense%20crime%20drama%20atmosphere%2C%20cool%20blue%20with%20warm%20accent%2C%20poster%20without%20text&width=600&height=900&seq=tv-mc-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=rainy%20metropolitan%20skyline%20at%20night%20with%20glowing%20windows%2C%20moody%20crime%20drama%20series%20still%2C%20deep%20blue%20and%20amber%20accents%20without%20text&width=1600&height=900&seq=tv-mc-backdrop&orientation=landscape',
    heat: 10240,
    updatedAt: '2025-10-08',
    synopsis: '一枚被反复转手的旧相机，串起了城市里五桩看似无关的案件。刑侦档案室的老警察带着年轻搭档，用最笨的办法把散落的碎片重新拼回真相。',
    featured: true,
  },
  {
    id: 'wang-chao-zhi-ying',
    title: '王朝之影',
    type: 'tv',
    year: 2024,
    region: '中国大陆',
    genres: ['历史', '权谋'],
    rating: 8.5,
    episodes: 45,
    director: '秦立',
    cast: ['江怀瑾', '沈砚', '柳含烟'],
    poster: 'https://readdy.ai/api/search-image?query=grand%20ancient%20chinese%20palace%20hall%20with%20tall%20red%20pillars%2C%20silhouette%20of%20a%20scholar%20in%20majestic%20robes%2C%20epic%20historical%20drama%20mood%2C%20deep%20vermilion%20and%20gold%20tones%2C%20poster%20without%20text&width=600&height=900&seq=tv-wc-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=majestic%20ancient%20chinese%20palace%20courtyard%20at%20dawn%20with%20layered%20rooftops%2C%20epic%20historical%20drama%20series%20still%2C%20deep%20red%20and%20golden%20palette%20without%20text&width=1600&height=900&seq=tv-wc-backdrop&orientation=landscape',
    heat: 8890,
    updatedAt: '2025-07-15',
    synopsis: '王朝暮年，年轻的史官在记录史实的职责与保护同僚的私心之间挣扎。一部看似平静的起居注，藏着足以撼动朝局的秘密，也藏着他一生的抉择。',
    featured: false,
  },
  {
    id: 'xin-tiao-pin-lv',
    title: '心跳频率',
    type: 'tv',
    year: 2025,
    region: '韩国',
    genres: ['爱情', '都市'],
    rating: 8.2,
    episodes: 16,
    director: '姜西元',
    cast: ['车允浩', '韩素恩', '崔智友'],
    poster: 'https://readdy.ai/api/search-image?query=bright%20modern%20romance%20scene%2C%20young%20couple%20sharing%20earphones%20in%20a%20sunny%20cafe%2C%20warm%20playful%20mood%2C%20soft%20peach%20and%20cream%20tones%2C%20poster%20without%20text&width=600&height=900&seq=tv-xt-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=sunny%20seoul%20city%20street%20in%20spring%20with%20blossoms%2C%20warm%20youthful%20romance%20series%20still%2C%20soft%20pink%20and%20amber%20palette%20without%20text&width=1600&height=900&seq=tv-xt-backdrop&orientation=landscape',
    heat: 9340,
    updatedAt: '2025-09-30',
    synopsis: '一位为广播剧定制音效的独立音乐人，遇见了对声音极度敏感的电台深夜主播。两个习惯用声音表达情绪的人，在电波与旋律之间慢慢靠近。',
    featured: true,
  },
  {
    id: 'shen-hai-xin-hao',
    title: '深海信号',
    type: 'tv',
    year: 2024,
    region: '美国',
    genres: ['科幻', '悬疑'],
    rating: 8.4,
    episodes: 10,
    director: 'Olivia Grant',
    cast: ['内森·科尔', '艾米·沃德', '丹尼尔·肖'],
    poster: 'https://readdy.ai/api/search-image?query=mysterious%20deep%20sea%20research%20station%20interior%20with%20blue%20glow%2C%20scientist%20watching%20a%20strange%20sonar%20signal%2C%20sci%20fi%20thriller%20atmosphere%2C%20teal%20and%20orange%20contrast%2C%20poster%20without%20text&width=600&height=900&seq=tv-sh-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=deep%20ocean%20trench%20with%20faint%20bioluminescent%20glow%20and%20a%20distant%20research%20submarine%2C%20sci%20fi%20series%20still%2C%20deep%20teal%20and%20amber%20accent%20palette%20without%20text&width=1600&height=900&seq=tv-sh-backdrop&orientation=landscape',
    heat: 7460,
    updatedAt: '2025-08-22',
    synopsis: '一支深海科考队在海沟深处捕捉到一段无法解释的规律信号。随着分析深入，队员们开始怀疑，收到信号的可能不只是他们，而海面之下也并非空无一人。',
    featured: false,
  },
  {
    id: 'ren-jian-yan-huo',
    title: '人间烟火',
    type: 'tv',
    year: 2024,
    region: '中国大陆',
    genres: ['都市', '家庭'],
    rating: 8.6,
    episodes: 36,
    director: '林晚了',
    cast: ['周晚宁', '程野', '宋奶奶'],
    poster: 'https://readdy.ai/api/search-image?query=cozy%20chinese%20neighborhood%20breakfast%20stall%20at%20early%20morning%2C%20steaming%20food%20and%20warm%20people%2C%20heartwarming%20slice%20of%20life%20mood%2C%20amber%20and%20cream%20tones%2C%20poster%20without%20text&width=600&height=900&seq=tv-rj-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=warm%20lively%20chinese%20old%20street%20in%20the%20evening%20with%20small%20shops%20and%20lanterns%2C%20heartwarming%20drama%20series%20still%2C%20golden%20amber%20and%20soft%20cream%20palette%20without%20text&width=1600&height=900&seq=tv-rj-backdrop&orientation=landscape',
    heat: 8020,
    updatedAt: '2025-07-28',
    synopsis: '一间开在老街口的小面馆，见证了街坊邻居十几年的悲欢。老板娘的账本上记的不只是账，还有每家每户借过的一碗面、一句安慰和一个未说出口的谢谢。',
    featured: false,
  },
  {
    id: 'zhu-lang-zhe',
    title: '逐浪者',
    type: 'tv',
    year: 2025,
    region: '中国大陆',
    genres: ['青春', '运动'],
    rating: 7.9,
    episodes: 24,
    director: '遇山',
    cast: ['陆星', '夏之', '高远'],
    poster: 'https://readdy.ai/api/search-image?query=energetic%20young%20surfers%20running%20toward%20bright%20ocean%20waves%20at%20sunrise%2C%20youthful%20sports%20drama%20mood%2C%20fresh%20teal%20and%20warm%20orange%20tones%2C%20poster%20without%20text&width=600&height=900&seq=tv-zl-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=wide%20sunny%20beach%20with%20breaking%20waves%20and%20colorful%20surfboards%2C%20energetic%20youth%20sports%20series%20still%2C%20bright%20teal%20and%20warm%20orange%20palette%20without%20text&width=1600&height=900&seq=tv-zl-backdrop&orientation=landscape',
    heat: 6610,
    updatedAt: '2025-08-11',
    synopsis: '海边小城的一支业余冲浪队，为了保住被收购的海滩，决定报名参加全国青年赛。一群成绩平平的少年，要在海浪和偏见之间划出自己的航线。',
    featured: false,
  },
  {
    id: 'dong-jing-mi-tu',
    title: '东京迷途',
    type: 'tv',
    year: 2023,
    region: '日本',
    genres: ['悬疑', '剧情'],
    rating: 8.3,
    episodes: 12,
    director: '大野拓真',
    cast: ['松田遥', '石井优', '中谷美咲'],
    poster: 'https://readdy.ai/api/search-image?query=quiet%20tokyo%20residential%20alley%20at%20dusk%20with%20vending%20machine%20glow%2C%20lone%20figure%20walking%20slowly%2C%20melancholic%20mystery%20mood%2C%20teal%20and%20amber%20tones%2C%20poster%20without%20text&width=600&height=900&seq=tv-dj-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=jam%20packed%20tokyo%20crossing%20at%20blue%20hour%20with%20neon%20signs%2C%20quiet%20mystery%20drama%20series%20still%2C%20cool%20teal%20and%20warm%20neon%20palette%20without%20text&width=1600&height=900&seq=tv-dj-backdrop&orientation=landscape',
    heat: 5990,
    updatedAt: '2025-06-18',
    synopsis: '一个在都市里替人「寻找遗失之物」的年轻男人，接到了寻找一名失踪女孩的委托。线索越清晰，他越发现自己也被卷进了一段没人愿意提起的往事。',
    featured: false,
  },
  {
    id: 'an-ye-chuan-shuo',
    title: '暗夜传说',
    type: 'tv',
    year: 2025,
    region: '英国',
    genres: ['奇幻', '冒险'],
    rating: 8.1,
    episodes: 8,
    director: 'Tom Hill',
    cast: ['奥利弗·琼斯', '艾拉·斯宾塞', '利亚姆·福特'],
    poster: 'https://readdy.ai/api/search-image?query=atmospheric%20fantasy%20forest%20at%20night%20with%20glowing%20blue%20runes%2C%20hooded%20traveler%20holding%20a%20lantern%2C%20epic%20adventure%20mood%2C%20deep%20teal%20and%20warm%20orange%20contrast%2C%20poster%20without%20text&width=600&height=900&seq=tv-ay-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=epic%20misty%20fantasy%20valley%20at%20dusk%20with%20ancient%20ruins%20and%20glowing%20crystals%2C%20cinematic%20fantasy%20series%20still%2C%20deep%20teal%20and%20amber%20palette%20without%20text&width=1600&height=900&seq=tv-ay-backdrop&orientation=landscape',
    heat: 7730,
    updatedAt: '2025-09-01',
    synopsis: '当维系世界的四盏古灯逐一熄灭，一名被判流放的向导被重新召回。她必须在暗夜彻底降临前，穿过只存在于传说中的峡谷，点亮最后一盏灯。',
    featured: false,
  },
  {
    id: 'yi-zhe-ren-xin',
    title: '医者仁心',
    type: 'tv',
    year: 2024,
    region: '中国大陆',
    genres: ['医疗', '剧情'],
    rating: 8.7,
    episodes: 40,
    director: '韩述',
    cast: ['苏怀安', '温岚', '傅明远'],
    poster: 'https://readdy.ai/api/search-image?query=dedicated%20doctor%20in%20a%20calm%20modern%20hospital%20corridor%20at%20dawn%2C%20soft%20light%20through%20tall%20windows%2C%20serious%20medical%20drama%20mood%2C%20clean%20teal%20and%20warm%20cream%20tones%2C%20poster%20without%20text&width=600&height=900&seq=tv-yz-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=bright%20modern%20hospital%20atrium%20with%20morning%20light%20and%20busy%20staff%2C%20hopeful%20medical%20drama%20series%20still%2C%20clean%20teal%20and%20warm%20cream%20palette%20without%20text&width=1600&height=900&seq=tv-yz-backdrop&orientation=landscape',
    heat: 8490,
    updatedAt: '2025-07-08',
    synopsis: '一名从基层卫生院调入大医院的主治医生，面对资源与规则的双重考验。他带着对病人最朴素的理解，在一个个生死抉择里，重新定义了「好医生」这三个字。',
    featured: false,
  },
  {
    id: 'bian-cheng-mi-an',
    title: '边城谜案',
    type: 'tv',
    year: 2025,
    region: '中国大陆',
    genres: ['悬疑', '年代'],
    rating: 8.5,
    episodes: 28,
    director: '秦岭',
    cast: ['顾行舟', '柳如烟', '段怀远'],
    poster: 'https://readdy.ai/api/search-image?query=remote%20border%20town%20in%201990s%20china%20at%20dusk%2C%20foggy%20street%20with%20a%20lone%20figure%20in%20overcoat%2C%20retro%20mystery%20mood%2C%20muted%20teal%20and%20amber%20tones%2C%20poster%20without%20text&width=600&height=900&seq=tv-bc-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=snowy%20remote%20chinese%20border%20town%20in%20winter%20evening%2C%20old%20houses%20and%20faint%20window%20lights%2C%20retro%20mystery%20series%20still%2C%20muted%20blue%20and%20warm%20amber%20palette%20without%20text&width=1600&height=900&seq=tv-bc-backdrop&orientation=landscape',
    heat: 7900,
    updatedAt: '2025-09-25',
    synopsis: '九十年代末，一座边陲小城因一桩旧案再次被卷入风波。被调离多年的老刑警回到故地，发现所有线索都指向当年那场无人愿意重提的大雪。',
    featured: false,
  },
];

export const featuredWorks = works.filter((w) => w.featured);

export const regions = ['全部', '中国大陆', '中国香港', '美国', '日本', '韩国', '英国'];
export const movieGenres = ['全部', '古装', '悬疑', '科幻', '剧情', '动作', '犯罪', '爱情', '家庭', '动画', '冒险'];
export const tvGenres = ['全部', '悬疑', '剧情', '历史', '权谋', '爱情', '都市', '科幻', '家庭', '青春', '运动', '奇幻', '医疗', '年代', '冒险'];